import { assign } from 'lodash'
import type { Component, WidgetRefDataItem, Style, Spx } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import type { RefArrayViewItem } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import type { VariablesCssData } from './variables.types'
import { getVariant } from '../../utils/toBreakpointVariantsMap'
import type { FeatureRefs } from '../cssFeatures.types'
import { getRefCompIdFromInflatedId, isInflatedId, getVariableCss } from '@wix/thunderbolt-commons'
import { DESKTOP_SPX, MOBILE_SPX } from './constants'

export const variables = createCssCompNode('variables', 'variables', {
	getDependencies: (component: Component, refs: FeatureRefs<'variables'>) => {
		return {
			variablesList: component.variablesQuery ? refs.variablesQuery(component.variablesQuery) : null,
			rootRefComponentData:
				component?.id && isInflatedId(component.id)
					? refs.dataQuery(`dataItem-${getRefCompIdFromInflatedId(component.id)}`)
					: null,
			environmentRefs: { renderSticky: envRefs.renderSticky },
			experiments: envRefs.experiments,
		}
	},
	toViewItem: (
		component,
		{ rootRefComponentData, variablesList, environmentRefs, experiments }
	): VariablesCssData | null => {
		if (!variablesList || !variablesList.variables) {
			return null
		}
		const isNewStyleApi = !!experiments['specs.thunderbolt.newStyleApi']

		return variablesList.variables.reduce<VariablesCssData>(
			(acc, { id: varId, name: varName, value: refArray, cssVarName }) => {
				const varKey = isNewStyleApi && cssVarName ? cssVarName : (rootRefComponentData as WidgetRefDataItem)?.isBuilderComponent ? varName ?? varId : varId

				refArray.values.forEach((val) => {
					const { breakpointId, variantsKey, value } = getVariant(val)
					acc[breakpointId] = acc[breakpointId] || {}
					acc[breakpointId][variantsKey] = acc[breakpointId][variantsKey] || {}
					assign(
						acc[breakpointId][variantsKey],
						getVariableCss(
							value,
							varKey,
							environmentRefs,
							isNewStyleApi,
							getSpxFromBreakpoint(breakpointId)
						)
					)
				})

				return acc
			},
			{}
		)
	},
})

/**
 * These constants are a temporary hack!
 * In the future we will have refWidth related to varianteable theme, which will include the spx.
 * BUT- for now, and for editor 3 specifically, this is enough.
 */

const getSpxFromBreakpoint = (breakpointId: string) => {
	return breakpointId === 'default' ? DESKTOP_SPX : MOBILE_SPX
}
